import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.571 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "27.571",
      height: "19",
      x: ".5",
      y: ".5",
      fill: "#fff",
      stroke: "#000",
      rx: "1.5"
    }, null, -1),
    _createElementVNode("path", { d: "M7.621 7.534c.253-.298.424-.697.379-1.106-.37.018-.82.23-1.081.528-.235.255-.442.671-.388 1.062.415.034.829-.195 1.09-.484M7.995 8.095c-.602-.034-1.114.322-1.401.322-.288 0-.728-.305-1.205-.297a1.8 1.8 0 0 0-1.509.865c-.647 1.051-.17 2.61.458 3.467.306.424.674.89 1.16.873.458-.017.637-.28 1.194-.28s.719.28 1.204.272c.503-.009.818-.424 1.123-.848.35-.483.494-.95.503-.975-.009-.008-.97-.356-.979-1.399-.009-.873.755-1.288.79-1.314-.43-.601-1.104-.67-1.338-.686M13.237 6.913c1.309 0 2.22.85 2.22 2.09 0 1.242-.93 2.097-2.253 2.097h-1.449v2.173h-1.047v-6.36zm-1.482 3.358h1.201c.912 0 1.43-.462 1.43-1.264s-.518-1.26-1.425-1.26h-1.206zM15.73 11.955c0-.81.659-1.309 1.827-1.37l1.346-.076v-.356c0-.516-.369-.825-.986-.825-.584 0-.949.265-1.037.68h-.954c.056-.838.813-1.455 2.029-1.455 1.191 0 1.953.595 1.953 1.525v3.195h-.967v-.763h-.024c-.285.516-.906.842-1.551.842-.963 0-1.636-.564-1.636-1.397m3.173-.419v-.365l-1.21.07c-.603.04-.944.29-.944.688 0 .405.355.67.897.67.706 0 1.257-.459 1.257-1.063M20.822 14.978v-.771c.075.017.243.017.327.017.467 0 .72-.185.874-.66 0-.01.089-.283.089-.287l-1.776-4.64h1.093l1.244 3.772h.018l1.244-3.773H25l-1.841 4.879c-.42 1.124-.907 1.485-1.926 1.485-.084 0-.336-.009-.411-.022" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "apple-pay"}) } }